import { Notification } from 'element-ui'

export default function notification({ title, message, type = 'info' }) {
  return Notification({
    title,
    message,
    // success, warning, info, error
    type
  })
}